import { useConnection } from "@solana/wallet-adapter-react";
import { PsyFiPositionFetcher } from "@stepfinance/vaults";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";
import { getTokenByMint } from "../../utils/tokenInfo";
import { useVaultsQuery } from "../queries/useVaultsQuery";

export const usePsyFiVaults = () => {
  const { connection } = useConnection();
  const { publicKey } = useEnrichedWallet();
  const { priceInUSD, marketsInitialised } = useMarkets();

  const {
    data: { psyFiVaults },
  } = useVaultsQuery();

  const fetcher = useMemo(() => {
    if (!publicKey || Object.values(psyFiVaults ?? {}).length === 0) {
      return undefined;
    }
    return new PsyFiPositionFetcher(publicKey, connection, psyFiVaults);
  }, [connection, psyFiVaults, publicKey]);

  const { data: positions } = useQuery(
    ["psyfi", publicKey?.toBase58()],
    async () => {
      if (!publicKey || !fetcher || !marketsInitialised) {
        return null;
      }
      return await fetcher.fetchPositions(priceInUSD, getTokenByMint);
    },
    {
      retry: false,
      enabled: !!publicKey && !!fetcher && marketsInitialised,
    },
  );

  return positions ?? [];
};
